import { CommunityModal } from '../ui';
import { useModalStore } from '@/shared/lib';

type OpenCommunityDialogParams = {
  onBack: () => void;
};

export function useCommunityModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openCommunityDialog = ({ onBack }: OpenCommunityDialogParams) => {
    showDialogComponent({
      component: <CommunityModal onBack={onBack} />,
      className:
        'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto bg-secondary-bg border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openCommunityDialog };
}
